import {
    combineReducers
} from "redux";
import accessReducer from "./reducers/accessService";
import accountReducer from "./reducers/accountService";
import appReducer from "./reducers/appService";
import organisationReducer from "./reducers/organisationService";
import tenantReducer from "./reducers/tenantService";

export default combineReducers({
    access: accessReducer,
    accounts: accountReducer,
    app: appReducer,
    organisations: organisationReducer,
    tenants: tenantReducer
});